@use "@/styles/variables" as v;

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes pulsate {
	0%,
	100% {
		transform: scale(1);
		opacity: 0.4;
	}
	50% {
		transform: scale(1.35);
		opacity: 0;
	}
}

.wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 4rem 2rem;
	animation: fadeInUp 0.4s ease-out both;
}

.iconContainer {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1.75rem;
}

.iconBg {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 88px;
	height: 88px;
	border-radius: 9999px;
	background-color: v.$primary-light;
	border: 2px solid v.$primary-color;
	position: relative;
	z-index: 1;
}

.icon {
	width: 44px;
	height: 44px;
	color: v.$primary-color;
}

.pulse {
	position: absolute;
	width: 88px;
	height: 88px;
	border-radius: 9999px;
	background-color: v.$primary-color;
	opacity: 0.2;
	animation: pulsate 2s ease-out infinite;
}

.title {
	font-size: 1.5rem;
	font-weight: 700;
	color: v.$gray-700;
	margin-bottom: 0.625rem;
}

.message {
	font-size: 0.9375rem;
	color: v.$gray-500;
	max-width: 380px;
	line-height: 1.6;
}
